import { useLocSettings } from "../hooks/SettingsHooks";
import PropTypes from "prop-types";
import IconWithPopup from "./IconWithPopup";

const IconsOrTagline = ({
  specsIndexed = {},
  showLabel = false,
  sku,
  noTooltips = false,
  tagline = ""
}) => {
  const settings = useLocSettings();

  const icons = Object.entries(specsIndexed)
    .map(([field, { value, unit, description }]) => {
      //TODO: const show_icon = settings.specifications?.[field]?.show_icon;
      const icon = settings.specifications?.[field]?.icons?.[value];
      return icon ? { field, value, unit, description, showLabel, sku } : null;
    })
    .filter(icon => icon !== null);

  return icons.length
    ? icons.map(({ field, value, unit, description, showLabel, sku }) => {
        return (
          <IconWithPopup
            field={field}
            value={value}
            unit={unit}
            description={description}
            showLabel={showLabel}
            key={field + "_" + value}
            sku={sku}
            noTooltip={noTooltips}
          />
        );
      })
    : tagline;
};

IconsOrTagline.propTypes = {
  specsIndexed: PropTypes.object.isRequired,
  showLabel: PropTypes.bool,
  tagline: PropTypes.string
};

export default IconsOrTagline;
